import { createLogger } from "../../logging/src";

export const zarazLog = createLogger("ZARAZ");
